/**
 * Cấu hình axios 1.x: base URL API v1, Bearer trên mọi request.
 * Xử lý lỗi HTTP tập trung ở BaseService.errorMsg — tránh redirect trùng (401/422/403).
 */
import axios from "axios";
import { resolveUserApiV1Base } from "../api/resolveBaseUrl";
axios.defaults.baseURL = resolveUserApiV1Base();
/** Không bật credentials mặc định — tránh CORS (* + credentials) trên /login. SSO/Sanctum gọi riêng. */
axios.interceptors.request.use((config) => {
    const headers = axios.AxiosHeaders.from(config.headers ?? {});
    if (typeof window !== "undefined" && window.location?.hostname) {
        headers.set("X-Social-Frontend-Host", window.location.hostname);
    }
    const token = localStorage.getItem("access_token");
    if (token) {
        const clean = String(token).replace("%", "|");
        headers.set("Authorization", `Bearer ${clean}`);
    }
    config.headers = headers;
    return config;
}, (err) => Promise.reject(err));
